import axios from "axios";
import { decryptRequest } from "../utils/crypt";

const getUsersList = async ({ current, pageSize }) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.get(
    `https://godrej.app-assertai.com:5000/User/userslist?page=${current}&limit=${pageSize}`,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  return { data: JSON.parse(dataafterdecryption) };
};
const deletUser = async ({ email }) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/User/deleteUser`,
    {
      email,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  return data.status;
};
const editUser = async ({
  requestedEmail,
  newUserName,
  newUserEmail,
  accessValueForNewUser,
  locationsSelected,
}) => {
  let token = localStorage.getItem("token");
  let { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/User/editUser`,
    {
      requestedEmail,
      name: newUserName,
      email: newUserEmail,
      access: accessValueForNewUser,
      locationType: locationsSelected,
    },
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
  return data.message;
};

export { getUsersList, deletUser, editUser };
